module.exports = __webpack_public_path__ + "img/landing-page-new-image.223bfe52.png";